import React, { useEffect, useState } from "react";
// import "./Tooltip.css";
import tip from "./OemAssets/tooltip.svg";

const TooltipTwo = (props) => {
    let timeout, closeTimeout;
    const [active, setActive] = useState(false);

    const showTip = () => {
        if (!active) {
            setActive(true)
        }
    };
    const isOem = sessionStorage.getItem("channel") === "OEMAPS1";
    useEffect(() => {
        if (!active) {
            clearInterval(closeTimeout)
        }
        if (active) {
            closeTimeout = setTimeout(() => {
                setActive(false);
            }, 3000)
        }
        return () => {
            clearInterval(closeTimeout)
        }
    }, [active])

    useEffect(() => {
        if (props.initialShow === true) {
            showTip()
        }
    }, [])

    console.log(props.content, 'siddd')

    const parsingContent = () => {

        let arr = []

        console.log("parse content >>>>>>", props.content);

        for (let index = 0; index < props.content.length; index++) {
            let element = props.content[index];
            console.log("hhhhhh nee ", element);
            let ele = <p style={{ color: "#E9DFCE" }}>{element}</p>

            arr.push(ele)
        }

        return arr

    }

    return (
        <div
            className="Tooltip-Wrapper"
            onTouchStart={() => props.redeemEducate === true ? null : showTip()}
            onMouseLeave={() => { setActive(false); clearInterval(closeTimeout) }}
            style={{ marginLeft: '5px' }}
        >
            {/* Wrapping */}
            {props.children}
            {active && (
                <div style={isOem?{marginTop: "0.75rem"}:{marginTop: "0"}}>
                    {isOem &&
                        <div style={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                            <img src={tip} width={"15px"}height={"10px"} style={{ position: 'absolute', top: '-8px', left: "4.1875rem", zIndex: "4", borderBottom:"1px solid #15191F"}}></img>
                        </div>}
                    <div id="contentDiv"style={{ display: 'flex', alignItems: 'center', flexDirection: "column", margin: "2%", height: "fit-content", left: "95%", top: "100%" }} className={props.pending ? `pending-tooltip ${props.direction || "top"}` : props.redeem ? `redeem-acepoints-tooltip ${props.direction || "top"}` : props.redeemEducate ? `redeemEducate ${props.direction || "top"}` : props.redeemAcePoints ? 'redeem-ace-points-info' : props.redeemProcessingFee ? 'redeem-processing-fee-info' : `Tooltip-Tip ${props.direction || "top"}`} >
                        {/* Content */}

                        {parsingContent()}
                        {/* {props.content} */}
                    </div>
                </div>

            )}
        </div>
    );
};

export default TooltipTwo;
